import { resetAccountMetrics } from "./accountMetricsSlice";
import { resetAccount } from "./accountSlice";
import { deAuthenticate } from "./authSlice";
import { resetCompetition } from "./competitionSlice";

export const deAuthenticateAll = (dispatch) => {
  dispatch(deAuthenticate());
  dispatch(resetAccount());
  dispatch(resetAccountMetrics());
  dispatch(resetCompetition());
};
